module.exports = __webpack_public_path__ + "1793882494189/fonts/WorkSans-Regular.a238b97.woff";